import type { AssetArticle } from '@repo/types/asset';

export const getArticleNo = (article: string) => article.replace(/^(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3');

export const getAssetArticleKey = (item: AssetArticle): string =>
    [item.type, item.referenceId, item.seqNo, item.groupNo, item.itemId, item.name].join(':');
